import { FunctionComponent } from "react";

import { List } from "../schema/list";
import { listHasCampaigns } from "../utils/listHasCampaigns";
import { ListActionLinks } from "./ListActionLinks";
import { RerunListButton } from "./RerunListButton";

interface ListDetailHeaderActionsProps {
	/** The loaded list detail, or undefined while it is still loading. */
	list?: List;
	/** Route list id (string form), used for the action links. */
	id: string;
	/** Whether the sequencer feature is active; `undefined` while the feature flags are still loading. */
	isSequencerActive?: boolean;
}

/**
 * Right-aligned action cluster in the list detail header: the re-run control plus the shared
 * list-action links (Sources / Find Person / Campaigns / Analytics / Settings). When the list has
 * no campaign yet, the Campaigns link becomes a "Create new Campaign" CTA (driven by
 * {@link listHasCampaigns}).
 */
export const ListDetailHeaderActions: FunctionComponent<ListDetailHeaderActionsProps> = ({
	list,
	id,
	isSequencerActive,
}) => (
	<div className="flex items-center gap-1">
		{list && <RerunListButton list={list} />}

		{list && <div className="w-px h-5 bg-border-light mx-1" />}

		<ListActionLinks
			entityType={list?.entityType}
			hasCampaigns={listHasCampaigns(list)}
			id={id}
			isSequencerActive={isSequencerActive}
			scrapeLevel={list?.scrapeLevel}
			sourceType={list?.sourceType}
			specialType={list?.specialType}
			variant="compact"
		/>
	</div>
);
